export function create_resize_observer() {    
    function debounce(func, ms) {
      let timeout;

      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), ms);
      }
    }

    let on_resized = debounce((entry) => {        
        let el = entry.target;
        let rect = el.getBoundingClientRect();

        el.trigger('resized', {
            width: rect.width,
            height: rect.height 
        })
    }, 150)

    return new ResizeObserver(entries => {
        for (const entry of entries) {
            on_resized(entry);
        }
    })   
}
